<ng-template #selectedItemTemplate let-item>
    {{ item.identifier }}
    <!-- <ng-container *ngIf="item.class"> - {{ item.class }}</ng-container>
    <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container> -->
</ng-template>
<ng-template #itemTemplate let-item>
    {{ item.identifier }}
    <ng-container *ngIf="item.class"> - {{ item.class }}</ng-container>
    <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container>
</ng-template>
